import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';
import { SCREEN_NAME } from '../constants';
import { useMyPageRoute } from '../../../hooks/useMyPageRoute';

export const useSetScreenName = () => {
  const { instanceId } = useMyPageRoute<'PointOfContact'>();

  useEffect(() => {
    bridge.setScreenName({ instanceId: instanceId, name: SCREEN_NAME });
  }, [instanceId]);
};
